import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { setupCalendar, Calendar, DatePicker } from 'v-calendar'
import axios from "@/api/customAxios";
import VueCookies from "vue-cookies";

/* import the fontawesome  */
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCalendar, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faListUl, faCakeCandles, faUmbrellaBeach, faUser, faCog, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faTimes, faPlus, faCheckCircle, faSync, faBullhorn, faClock, faCheck, faArrowRight, faCircleInfo, faClipboardCheck, faBars, faCalendarAlt, faList, faMagnifyingGlass, faAngleDown, faEye, faEyeSlash, faCalendarDay, faBriefcase, faUsersCog, faCircleQuestion, faCalendarXmark, faGift, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faEye as farEye, faEyeSlash as farEyeSlash } from "@fortawesome/free-regular-svg-icons";
library.add(faCalendar, faListUl, faCakeCandles, faUmbrellaBeach, faTrashCan, faUser, faCog, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faTimes, faPlus, faCheckCircle, faSync, faBullhorn, faClock, faCheck, faArrowRight, faCircleInfo, faClipboardCheck, faBars, faCalendarAlt, faList, faMagnifyingGlass, faAngleDown, faEye, faEyeSlash, farEye, farEyeSlash, faCalendarDay, faBriefcase, faUsersCog, faCircleQuestion, faCalendarXmark, faGift, faEnvelope);

// View Js
import * as common from '@/common/js'
import * as filters from '@/common/js/filter'

// View CSS Area Start
import '@/assets/css/design-tokens.css'
import '@/assets/css/common.css'
import '@/assets/css/contents.css'
import '@/assets/css/loading.css'
import 'v-calendar/dist/style.css'
import CryptoJS from "crypto-js";

// 개발자 도구에서만 사용되도록 설정
if (process.env.NODE_ENV === 'development') {
    window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true;
}

const app = createApp(App)
app.use(router)
app.use(store)
// 추가 라이브러리
app.use(setupCalendar, {})
app.use(VueDOMPurifyHTML)
app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)
app.component("font-awesome-icon", FontAwesomeIcon)
app.use(VueCookies);

// 전역변수 선언
app.config.globalProperties.$store = store
app.config.globalProperties.$router = router
app.config.globalProperties.$axios = axios
app.config.globalProperties.$filters = filters
app.mount('#app')
